export const ROLE = {
  NEW_USER: "0",
  SENIOR_SALES_MANAGER: "2",
  SALES_MANAGER: "3",
  SALES_CONSULTANT: "4",
  GENERAL_MANAGER: "5",
  OWNER: "6",
}

export const ROLENAME = {
  SENIOR_SALES_MANAGER: "Senior Sales Manager",
  SALES_MANAGER: "Sales Manager",
  SALES_CONSULTANT: "Sales Consultant",
  GENERAL_MANAGER: "General Manager",
  OWNER: "Owner",
}

export const roleOptions = [
  { value: ROLE.SENIOR_SALES_MANAGER, label: ROLENAME.SENIOR_SALES_MANAGER },
  { value: ROLE.SALES_MANAGER, label: ROLENAME.SALES_MANAGER },
  { value: ROLE.SALES_CONSULTANT, label: ROLENAME.SALES_CONSULTANT },
  { value: ROLE.GENERAL_MANAGER, label: ROLENAME.GENERAL_MANAGER },
  { value: ROLE.OWNER, label: ROLENAME.OWNER },
]

export const userStatuses = {
  pending: "pending",
  approved: "approved",
  verified: "verified",
  unverified: "unverified",
  inactive: "inactive",
  signupInProgress: "signup-in-progress",
  notMigrated: "not-migrated",
}

export const signupStep = {
  wallet: "wallet",
  billing: "billing",
  finished: "finished",
}
